import { render, staticRenderFns } from "./formgroupselect2.vue?vue&type=template&id=490e0629&"
import script from "./formgroupselect2.vue?vue&type=script&lang=js&"
export * from "./formgroupselect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports